// @ts-strict-ignore
import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LMDimension } from '@modal/cubes/lm-cubes';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMCubeUtilService } from '@modal/cubes/lm-cube-util.service';

@Component({
  selector:    'lm-cube-period-dimension',
  standalone: false,
  templateUrl: './lm-cube-period-dimension.component.html',
})

export class LMCubePeriodDimensionComponent implements OnInit {
  @ViewChild('periodPlaceholder', { read: ViewContainerRef, static: true }) placeholder: ViewContainerRef;
  @Input() dimension: LMDimension;

  public id: string;
  public launchButtonTooltip: string;

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private lmCubeUtilService: LMCubeUtilService,
  ) {}

  ngOnInit(): void {
    this.id = this.lmUniqueIdService.uniqueId(['cube-cell-dimension', this.dimension.type, this.dimension.name]);
    this.launchButtonTooltip = Soho.Locale.translate('CurrentPeriod');
  }

  public openPeriodDialog() {
    this.lmCubeUtilService.openPeriodDialogForPeriodDimension(this.placeholder, this.dimension.interval, this.dimension.currentPeriod)
      .subscribe((periodKey: string) => {
        this.dimension.value = periodKey;
        this.dimension.currentPeriod = this.dimension.value.replace(/\/\w*\//, '\n');
      });
  }

}
